import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Product from './icon-product.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Product {...validProps} />;
}
SvgComponent.iconName = 'product';

export const ProductIcon = svgIconWrapper(SvgComponent);
